import { render, staticRenderFns } from "./mortgage-calculators-tabs.vue?vue&type=template&id=01358453"
import script from "./mortgage-calculators-tabs.vue?vue&type=script&lang=ts"
export * from "./mortgage-calculators-tabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports